export const decodeSpecialChar = (value: string) => {
  const html = document.createElement('textarea');
  html.innerHTML = value;
  return html.value;
};
